/**
 * Establecer datos para el listado de paises.
 *
 * @param {*} state
 * @param {*} nextCountries
 * @author Fernando CLaros Garcia
 */
export function setCountries(state, nextCountries) {
    state.countries = nextCountries;
}

/**
 * Establecer datos para el listado de paises y empresas.
 *
 * @param {*} state
 * @param {*} countriesWithEnterprises
 * @returns void
 */
export function setCountriesWithEnterprises(state, countriesWithEnterprises) {
    state.countriesWithEnterprises = countriesWithEnterprises;
}

/**
 * Establecer datos para el listado de paises y codigos telefonicos.
 *
 * @param {*} state
 * @param {*} countriesWithPhoneCodes
 * @returns void
 */
export function setCountriesWithPhoneCodes(state, countriesWithPhoneCodes) {
    state.countriesWithPhoneCodes = countriesWithPhoneCodes;
}
